export function arrayToMap<T, K extends keyof T>(
  array: T[],
  key: K
): Map<K, T> {
  const map = new Map();
  array.forEach((item: T) => map.set(item[key], item));
  return map;
}
